<template>
  <div>
    <a-tooltip placement="top">
      <template slot="title">
        <span>Descargar hoja de vida acádemica</span>
      </template>
      <a-button @click="() => downloadProject()" style="position: absolute;right:3em;z-index:10; pad" type="primary" shape="circle" icon="download" class="ml-3"/>
    </a-tooltip>
    <b-row class="p-2">
      <b-col>
        <b-form-group
          label="Logros/reconocimientos obtenidos:"
          label-for="textarea-formatter"
          :description="checkRemaining(form.academicGoals.length, 1050)"
          class="mb-0"
        >
          <b-form-textarea
            id="textarea-formatter"
            rows="5"
            v-model="form.academicGoals"
            maxlength="1050"
            placeholder="Descripción breve del proyecto"
          ></b-form-textarea>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col xl="2">
        <b-button variant="primary" @click="save()">Guardar</b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Swal from 'sweetalert2'
import apiClient from '@/services/axios'
import axios from 'axios'
import store from 'store'
import { showErrorMessage } from '@/services/utilities'

const Toast = Swal.mixin({
  toast: true,
  position: 'top-end',
  showConfirmButton: false,
  timer: 6000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer)
    toast.addEventListener('mouseleave', Swal.resumeTimer)
  },
})

export default {
  components: {
  },
  name: 'academicProfile',
  props: {
  },
  data() {
    return {
      form: {
        academicGoals: '',
      },
    }
  },
  created: function () {
  },
  mounted: function () {
    apiClient.get('/academic-projects/').then(response => {
      if (response.data.academicGoals !== null) {
        this.form.academicGoals = response.data.academicGoals.academicGoals
      }
    }).catch(error => {
      this.$notification.error({
        message: 'Ooops ocurrió un error',
        description: showErrorMessage(error),
      })
    })
  },
  updated: function () {
  },
  beforeDestroy: function () {
  },
  methods: {
    setData() {
    },
    checkRemaining(x, y) {
      return (y === 5) ? (y - x) + ' palabras restantes' : (y - x) + ' caracteres restantes'
    },
    downloadProject() {
      let url = ''
      url = process.env.VUE_APP_API_URL + '/academic-projects/download-cv'
      const headers = {
        Authorization: `Bearer ${store.get('accessToken')}`,
        AccessToken: store.get('accessToken'),
      }
      axios({
        url: url,
        method: 'GET',
        responseType: 'blob', // Important
        headers: headers,
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        const filename = `Hoja_de_vida_${this.$store.state.user.name}.pdf`
        link.setAttribute('download', filename) // or any other extension
        document.body.appendChild(link)
        link.click()
        Toast.fire({
          icon: 'success',
          title: 'Hoja de vida descargada correctamente',
        })
      }).catch(error => {
        console.log(error)
        Toast.fire({
          icon: 'warning',
          title: 'Ooops ocurrió un error',
        })
      })
    },
    save() {
      if (this.form.academicGoals.length < 1) {
        return Toast.fire({
          icon: 'warning',
          title: 'El campo no debe estar vacío',
        })
      }
      apiClient.patch('/academic-projects/academic-goals/' + this.$store.state.user.id, { form: this.form }).then(response => {
        Toast.fire({
          icon: 'success',
          title: 'Información guardada correctamente en su hoja de vida académica',
        })
        this.cleanAndBack(1)
      }).catch(err => {
        Toast.fire({
          icon: 'error',
          title: 'Ooops ocurrio un error' + showErrorMessage(err),
        })
      })
    },
    cleanAndBack() {
      this.$emit('finished')
    },
  },
}
</script>
